/**
 * Wrapper around existing API client
 * Imports from the current api.ts file
 *
 * TODO: Delete this entire file once backend is updated
 */

import {
  getAllProperties,
  getAllStats,
  getPropertyRevenue,
  getPageStats,
  getClickStats,
  getFormStats,
  realTimeUserStats,
  createProperty,
  updateProperty,
  archiveProperty as deleteProperty,
  getHeatmapAuth,
  getHeatmapPages,
  getSavedFunnels,
  saveFunnel,
  getExperimentsList as getExperiments,
  createExperiment,
} from "@/lib/api/api";

/**
 * Re-export current API functions
 * This makes it explicit which legacy functions we're calling
 */
export const legacyClient = {
  // Properties
  getAllProperties,
  createProperty,
  updateProperty,
  deleteProperty,

  // Metrics
  getAllStats,
  getPropertyRevenue,
  getPageStats,
  getClickStats,
  getFormStats,
  realTimeUserStats,

  // Heatmaps
  getHeatmapAuth,
  getHeatmapPages,

  // Funnels
  getSavedFunnels,
  saveFunnel,

  // Experiments
  getExperiments,
  createExperiment,
};
